<template>
  <div class="section">

    <div class="container is-fullhd">
      <div class="hero is-primary is-fullheight">
      <div class="hero-body">

        <div class="logo-float  has-text-centered">
          <h2 class="subtitle">Welcome to</h2>
          <h1 class="title">
            <img src="../assets/truckl-logo.png" />
          </h1>
          <h2 class="subtitle ">
            The Road to Trust
          </h2>
        </div>

        <div class="container">
          <div class="columns">

          <div class="column is-two-thirds has-text-centered">
            <!--
            <h2 class="subtitle">Welcome to</h2>
            <h1 class="title">
              <img src="../assets/truckl-logo.png" />
            </h1>
            <h2 class="subtitle ">
              The Road to Trust
            </h2>
            -->
          </div>

          <div class="column">
            <div class="box">
              <login-form></login-form>
            </div>

            <p class="is-size-5 has-text-dark has-text-centered">New to Truckl...? Register now</p>
            <div class="columns">
              <div class="column">
                <router-link class="button is-medium is-dark is-fullwidth"
                             :to="{ name: 'carrier-registration-userinfo' }">
                  <span class="icon">
                    <font-awesome-icon icon="dolly" />
                  </span>
                  <span>
                    As a carrier
                  </span>
                </router-link>
              </div>
              <div class="column">
                <router-link class="button is-medium is-dark is-fullwidth"
                             :to="{ name: 'shipper-registration-userinfo' }">
                  <span class="icon">
                    <font-awesome-icon icon="shipping-fast" />
                  </span>
                  <span>
                    As a shipper
                  </span>
                </router-link>
              </div>
            </div>
          </div>

        </div>
        </div>
      </div>
    </div>
    </div>

  </div>
</template>

<script>
import LoginForm from '@/components/FormLogin'
export default {
  name: 'LoginPage',

  components: {
    LoginForm
  }
}
</script>

<style scoped lang="scss">
.logo-float {
  position: absolute;
  top: 25px;
  left: 25px;
}

.section {
  margin-bottom: -100px;
  // background: linear-gradient(to right, #ffffff 0%, #fdbf2d 51%, #ffffff 100%);
  z-index: 0;
  zoom: 1;
  padding: 0;

  &::after {
    content: '';
    background-image: url('../assets/backgrounds/image001.jpg');
    background-size: cover;
    // background-position: 0 -90px;
    background-repeat: no-repeat;
    opacity: 0.5;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: fixed;
    z-index: -1;
  }
}
.hero {
  /*
  background-image: url('../assets/backgrounds/image001.png');
  background-size: cover;
  background-position: 0 -90px;
  background-repeat: no-repeat;
  */
  height: 100vh;
  min-height: 0;
  max-height: 900px !important;

  &.is-primary {
    background-color: transparent;

    .subtitle {
      color: black;
    }
  }
}
</style>
